import type { FreightClaimLineItem } from "@freightsimple/generated-dashboard-openapi-client/models/FreightClaimLineItem";
import { sumOf } from "./sumOf";

export function calculateTotalFreightClaim(
  claimLineItems: FreightClaimLineItem[],
): number {
  const total = sumOf(claimLineItems, (o) =>
    o.unitCost === undefined || o.piecesAffected === undefined
      ? 0
      : o.unitCost * o.piecesAffected,
  );

  return parseFloat(total.toFixed(2));
}
